var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lighting"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M65.1,30.3c-14.21,0-25.73,11.25-25.73,25.13,0,15.77,12.87,22.79,16.37,34.48H74.46C78,78.22,90.83,71.2,90.83,55.43,90.83,41.55,79.31,30.3,65.1,30.3ZM63.93,46.64h2.34V59.51H63.93Zm9.31,24.12a12.5,12.5,0,0,1-7.87,2.78,12.78,12.78,0,0,1-2.74-.3,12.57,12.57,0,0,1-3.75-23l1.21,2A10.24,10.24,0,1,0,70.3,52l1.12-2.05a12.55,12.55,0,0,1,1.82,20.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 55.74,
    y: 95.76,
    width: 18.71,
    height: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M65.1,113.3c-7.84,0-9.26-5.33-9.32-5.56l0-.28V104H74.46l0,3.79C74.36,108,72.94,113.3,65.1,113.3Zm-7-6c.23.63,1.58,3.68,7,3.68s6.79-3,7-3.68v-1h-14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 63.93,
    y: 13.9,
    width: 2.34,
    height: 9.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 23,
    y: 56,
    width: 9.36,
    height: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 35.86,
    y: 25.59,
    width: 2.34,
    height: 9.35,
    transform: "translate(-10.56 35.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 32.36,
    y: 84.07,
    width: 9.35,
    height: 2.34,
    transform: "translate(-49.42 51.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 97.64,
    y: 56,
    width: 9.36,
    height: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 88.29,
    y: 29.1,
    width: 9.36,
    height: 2.34,
    transform: "translate(5.82 74.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 91.8,
    y: 80.56,
    width: 2.34,
    height: 9.36,
    transform: "translate(-33.04 90.71) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.5604e6261c0e405f6724b53fcb6fadfc.svg";
export { ForwardRef as ReactComponent };